import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UtilityService } from 'src/app/modules/accounts-module/accounts/services/utility-service';
import { CustomerModel } from '../../models/customer-model';
import { CustomerMasterService } from '../../services/customer-master-service';
import { SmSMasterService } from '../../services/sms-master-service';
import { SmsListDto, SmsListFilterPayload } from '../../models/sms-list-model';
import { TransactionStatus, TransactionType } from '../../models/transaction.enum';

@Component({
  selector: 'app-sms-list',
  templateUrl: './sms-list.component.html',
  styleUrls: ['./sms-list.component.css']
})
export class SmsListComponent implements OnInit, AfterViewInit {
  // Filters
  filterTransactionType: string = TransactionType. INVOICE;
  filterCustomerId: number | null = null;
  filterStatus: string = 'All';
  filterIsActive: string = 'All';
  public l_UserRole: string = '';

  // Dropdown Data
   transactionTypes = [
      { value: TransactionType.INVOICE, viewValue: 'Invoice' }
    ];
  customerList: CustomerModel[] = [];
  statusOptions = [
     { value: TransactionStatus.PENDING, viewValue: 'Pending' },
     { value: TransactionStatus.SENT, viewValue: 'Sent' }
   ];

  // Table Properties
  displayedColumns: string[] = [
    'srNo',
    'transactionNo',
    'customerName',
    'serviceName',
    'serviceExpiry',
    'smsScheduledOn',
    'smsStatus',
    'isActive'
  ];
  dataSource = new MatTableDataSource<SmsListDto>([]);
  originalData: SmsListDto[] = []; 

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private _utilityService: UtilityService,
    private _customerService: CustomerMasterService,
    private _smsMasterService: SmSMasterService
  ) { }

  async ngOnInit(): Promise<void> {
    this.l_UserRole = sessionStorage.getItem('role') || '';

    if (this.l_UserRole === 'SUPER_ADMIN') {
      this.transactionTypes = [
        // { value: TransactionType.QUOTATION, viewValue: 'Quotation' },
        // { value: TransactionType.DIRECT_ORDER, viewValue: 'Direct Order' },
        // { value: TransactionType.ORDER, viewValue: 'Order' },
        { value: TransactionType.INVOICE, viewValue: 'Invoice' }
      ];
    } else {
      this.transactionTypes = [
        { value: TransactionType.INVOICE, viewValue: 'Invoice' }
      ];
      this.filterTransactionType = TransactionType.INVOICE;
    }

    await this.lFN_LoadCustomers();
    this.lFN_SearchSMS(); 
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  async lFN_LoadCustomers(): Promise<void> {
    this._customerService.lFN_GetCustomerList().subscribe({
      next: (res: any) => {
        const parsed = JSON.parse(res.body);
        this.customerList = parsed?.data || [];
      },
      error: () => console.error('Failed to load customers'),
    });
  }

  lFN_SearchSMS(): void {
    if (!this.filterTransactionType) {
      this._utilityService.lFN_ErrorToaster('Transaction Type is mandatory', 'Warning');
      return;
    }

    this._utilityService.lFN_ShowLoader();

    const payload: SmsListFilterPayload = {
      transactionType: this.filterTransactionType,
    };

    if (this.filterCustomerId) payload.customerId = this.filterCustomerId;
    
    if (this.filterIsActive !== 'All') {
      payload.isActive = this.filterIsActive === 'Yes' ? 'YES' : 'NO';
    }
    if (this.filterStatus !== 'All') {
      payload.status = this.filterStatus;
    }

    this._smsMasterService.lFN_GetSmSListFilter(payload).subscribe({
      next: (res: any) => {
        this._utilityService.lFN_HideLoader();
        const parsed = typeof res.body === 'string' ? JSON.parse(res.body) : res.body;
        const data = parsed?.data || [];
        
        // Map API response array into the UI DTO Model
        this.originalData = data.map((item: any, index: number) => ({
          srNo: item.srNo || (index + 1),
          transactionNo: item.transactionNumber || '-',
          customerName: item.customerName || '-',
          serviceName: item.serviceName || '-',
          serviceExpiry: item.serviceExpiry,
          smsScheduledOn: item.smsScheduledOn,
          smsStatus: this.mapStatus(item.status),
          isActive: item.isActive || 'NO'
        }));
        
        this.bindDataToTable();
      },
      error: () => {
        this._utilityService.lFN_HideLoader();
        this._utilityService.lFN_ErrorToaster('Failed to load scheduled SMS list', 'Error');
        this.dataSource.data = [];
        this.originalData = [];
      },
    });
  }

  applyFilters(): void {
    // Trigger backend search on frontend dropdown changes
    this.lFN_SearchSMS();
  }

  onTypeChange(): void {
    this.lFN_SearchSMS();
  }

  bindDataToTable(): void {
    this.dataSource.data = [...this.originalData];
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  lFN_ResetFilters(): void {
    this.filterTransactionType = TransactionType.INVOICE;
    this.filterCustomerId = null;
    this.filterStatus = 'All';
    this.filterIsActive = 'All';
    this.lFN_SearchSMS();
  }

  mapStatus(status: string): string {
    const statusMap: { [key: string]: string } = {
      'P': 'Pending', 'S': 'Sent', 'D': 'Delivered', 'F': 'Failed', 'C': 'Cancelled'
    };
    return statusMap[status] || status || 'Unknown';
  }

  lFN_ToggleActive(row: SmsListDto): void {
    // Feature toggle SMS log implementation goes here if endpoint exists
    //this._utilityService.lFN_WarningToaster('Toggle active feature not implemented yet.', 'Info');
  }
}
